/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateUpdateReceiptPositionDto } from './CreateUpdateReceiptPositionDto';
import {
    CreateUpdateReceiptPositionDtoFromJSON,
    CreateUpdateReceiptPositionDtoFromJSONTyped,
    CreateUpdateReceiptPositionDtoToJSON,
} from './CreateUpdateReceiptPositionDto';

/**
 * 
 * @export
 * @interface CreateUpdateReceiptDto
 */
export interface CreateUpdateReceiptDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateReceiptDto
     */
    receiptType?: CreateUpdateReceiptDtoReceiptTypeEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateReceiptDto
     */
    receiptDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateReceiptDto
     */
    amountGross?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateReceiptDto
     */
    paymentMethod?: CreateUpdateReceiptDtoPaymentMethodEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateReceiptDto
     */
    examId?: string | null;
    /**
     * 
     * @type {Array<CreateUpdateReceiptPositionDto>}
     * @memberof CreateUpdateReceiptDto
     */
    receiptPositions?: Array<CreateUpdateReceiptPositionDto>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateReceiptDto
     */
    fiscalized?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateReceiptDto
     */
    printerUid?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateReceiptDto
     */
    jpkId?: number | null;
}


/**
 * @export
 */
export const CreateUpdateReceiptDtoReceiptTypeEnum = {
    Fiscal: 'Fiscal',
    EFiscal: 'EFiscal'
} as const;
export type CreateUpdateReceiptDtoReceiptTypeEnum = typeof CreateUpdateReceiptDtoReceiptTypeEnum[keyof typeof CreateUpdateReceiptDtoReceiptTypeEnum];

/**
 * @export
 */
export const CreateUpdateReceiptDtoPaymentMethodEnum = {
    Cash: 'Cash',
    BankTransfer: 'BankTransfer',
    Card: 'Card',
    Mobile: 'Mobile'
} as const;
export type CreateUpdateReceiptDtoPaymentMethodEnum = typeof CreateUpdateReceiptDtoPaymentMethodEnum[keyof typeof CreateUpdateReceiptDtoPaymentMethodEnum];


/**
 * Check if a given object implements the CreateUpdateReceiptDto interface.
 */
export function instanceOfCreateUpdateReceiptDto(value: object): value is CreateUpdateReceiptDto {
    return true;
}

export function CreateUpdateReceiptDtoFromJSON(json: any): CreateUpdateReceiptDto {
    return CreateUpdateReceiptDtoFromJSONTyped(json, false);
}

export function CreateUpdateReceiptDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateReceiptDto {
    if (json == null) {
        return json;
    }
    return {
        
        'receiptType': json['receiptType'] == null ? undefined : json['receiptType'],
        'receiptDate': json['receiptDate'] == null ? undefined : (new Date(json['receiptDate'])),
        'amountGross': json['amountGross'] == null ? undefined : json['amountGross'],
        'paymentMethod': json['paymentMethod'] == null ? undefined : json['paymentMethod'],
        'examId': json['examId'] == null ? undefined : json['examId'],
        'receiptPositions': json['receiptPositions'] == null ? undefined : ((json['receiptPositions'] as Array<any>).map(CreateUpdateReceiptPositionDtoFromJSON)),
        'fiscalized': json['fiscalized'] == null ? undefined : json['fiscalized'],
        'printerUid': json['printerUid'] == null ? undefined : json['printerUid'],
        'jpkId': json['jpkId'] == null ? undefined : json['jpkId'],
    };
}

export function CreateUpdateReceiptDtoToJSON(value?: CreateUpdateReceiptDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'receiptType': value['receiptType'],
        'receiptDate': value['receiptDate'] == null ? undefined : ((value['receiptDate'] as any).toISOString()),
        'amountGross': value['amountGross'],
        'paymentMethod': value['paymentMethod'],
        'examId': value['examId'],
        'receiptPositions': value['receiptPositions'] == null ? undefined : ((value['receiptPositions'] as Array<any>).map(CreateUpdateReceiptPositionDtoToJSON)),
        'fiscalized': value['fiscalized'],
        'printerUid': value['printerUid'],
        'jpkId': value['jpkId'],
    };
}

